// Aviso de versión nueva: nunca se actualiza sola mientras el cliente arma un pedido.
import { Icono } from '@reparto/ui';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Boton } from './base';

export function AvisoVersion() {
  const {
    needRefresh: [hayNueva, setHayNueva],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });
  if (!hayNueva) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-3 top-3 z-50 flex items-center gap-3 rounded-2xl bg-stone-900 p-3 text-[15px] text-white shadow-lg sm:mx-auto sm:max-w-lg"
    >
      <Icono nombre="system_update" />
      <span className="flex-1">Hay una versión nueva de la tienda.</span>
      <Boton tamano="sm" className="h-11!" onClick={() => void updateServiceWorker(true)}>
        Actualizar
      </Boton>
      <button
        type="button"
        onClick={() => setHayNueva(false)}
        aria-label="Más tarde"
        className="grid h-11 w-11 place-items-center rounded-full hover:bg-white/10"
      >
        <Icono nombre="close" />
      </button>
    </div>
  );
}
